/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { BackendSiteSettings } from './BackendSiteSettings';
import { FrontendSiteSettings } from './FrontendSiteSettings';
const AllSiteSettingsParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(BackendSiteSettings, FrontendSiteSettings);
export class AllSiteSettings extends FrontendSiteSettings {
    static decode(input) {
        return AllSiteSettingsParser.decode(input).map(res => new AllSiteSettings(res));
    }
    static unsafeDecode(input) {
        return AllSiteSettings.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AllSiteSettingsParser.encode(data);
    }
    static schema() {
        return AllSiteSettingsParser.schema();
    }
}
